module.exports = __webpack_public_path__ + "asset/huiguActive_1Y7XzyH5.png";